import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import BroadCastSection from "./broadCastSection";
import SelectBroadCast from "./selectBroadCast";

import db from "../../../db/index.json";

// onClick={onBack}

const BroadCast = ({ onBack }) => {
  const { broadcasts } = db;
  const [isDetailData, setIsDetailData] = useState(broadcasts.broadCastData[0]);

  const onViewDetails = (item) => {
    setIsDetailData(item)
  }

  const [search, setSearch] = useState("")

  return (
    <div>
      <div className="h-screen">
        <div className="h-[10vh] pr-2">
          <SearchBar onChange={(e) => {
            setSearch(e.target.value)
          }} title={broadcasts.title} desc={broadcasts.subTitle} />
        </div>
        <div className="h-[90vh]">
          <div className="flex justify-between pt-5 h-full">
            <div className="w-[100%] h-full">
              <BroadCastSection search={search} onViewDetails={onViewDetails} />
            </div>
            {/* <div className="w-[40%]">
              <SelectBroadCast data={isDetailData}/>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BroadCast;
